import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Button, Datepicker, Modal, ModalFooter, RadioButton, TextArea, TextField, } from "@folio/stripes/components";
import styles from "./PostponeCheckDialog.module.css";
var MIN_DAYS = 1;
var MAX_DAYS = 1825;
var isFutureDate = function (value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return false;
    }
    var parsed = new Date("".concat(value, "T00:00:00"));
    return !Number.isNaN(parsed.getTime()) && parsed > new Date();
};
export var PostponeCheckDialog = function (_a) {
    var open = _a.open, defaultDays = _a.defaultDays, titleName = _a.titleName, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, _c = _a.titleMessageId, titleMessageId = _c === void 0 ? "ui-br-legaldeposits.periodicalCheck.postpone.title" : _c, _d = _a.introMessageId, introMessageId = _d === void 0 ? "ui-br-legaldeposits.periodicalCheck.postpone.intro" : _d, _f = _a.cancelMessageId, cancelMessageId = _f === void 0 ? "ui-br-legaldeposits.button.cancel" : _f, onClose = _a.onClose, onSubmit = _a.onSubmit;
    var formatMessage = useIntl().formatMessage;
    var _g = useState("days"), mode = _g[0], setMode = _g[1];
    var _h = useState(defaultDays), days = _h[0], setDays = _h[1];
    var _j = useState(""), until = _j[0], setUntil = _j[1];
    var _k = useState(""), note = _k[0], setNote = _k[1];
    useEffect(function () {
        if (open) {
            setMode("days");
            setDays(defaultDays);
            setUntil("");
            setNote("");
        }
    }, [open, defaultDays]);
    var daysValid = days >= MIN_DAYS && days <= MAX_DAYS;
    var isValid = mode === "days" ? daysValid : isFutureDate(until);
    var handleSubmit = function () {
        var trimmedNote = note.trim() || undefined;
        if (mode === "days") {
            onSubmit({ days: days, note: trimmedNote });
        }
        else {
            onSubmit({ until: until, note: trimmedNote });
        }
    };
    return (React.createElement(Modal, { open: open, onClose: onClose, label: formatMessage({ id: titleMessageId }), dismissible: true, footer: React.createElement(ModalFooter, null,
            React.createElement(Button, { buttonStyle: "primary", onClick: handleSubmit, disabled: !isValid || isLoading }, formatMessage({
                id: "ui-br-legaldeposits.periodicalCheck.postpone.submit",
            })),
            React.createElement(Button, { onClick: onClose, disabled: isLoading }, formatMessage({ id: cancelMessageId }))) },
        React.createElement("p", null, formatMessage({ id: introMessageId }, { title: titleName !== null && titleName !== void 0 ? titleName : "" })),
        React.createElement(RadioButton, { name: "postponeMode", checked: mode === "days", onChange: function () { return setMode("days"); }, label: formatMessage({
                id: "ui-br-legaldeposits.periodicalCheck.postpone.modeDays",
            }) }),
        mode === "days" && (React.createElement("div", { className: styles.nestedField },
            React.createElement(TextField, { type: "number", value: days, min: MIN_DAYS, max: MAX_DAYS, onChange: function (e) {
                    return setDays(parseInt(e.target.value, 10) || 0);
                }, label: formatMessage({
                    id: "ui-br-legaldeposits.periodicalCheck.postpone.daysLabel",
                }), error: daysValid
                    ? undefined
                    : formatMessage({
                        id: "ui-br-legaldeposits.periodicalCheck.postpone.daysError",
                    }) }))),
        React.createElement(RadioButton, { name: "postponeMode", checked: mode === "until", onChange: function () { return setMode("until"); }, label: formatMessage({
                id: "ui-br-legaldeposits.periodicalCheck.postpone.modeUntil",
            }) }),
        mode === "until" && (React.createElement("div", { className: styles.nestedField },
            React.createElement(Datepicker, { value: until, onChange: function (_e, _displayed, isoDate) {
                    return setUntil(isoDate);
                }, backendDateStandard: "YYYY-MM-DD", dateFormat: "DD/MM/YYYY", placeholder: "DD/MM/RRRR", label: formatMessage({
                    id: "ui-br-legaldeposits.periodicalCheck.postpone.untilLabel",
                }), error: until.length > 0 && !isFutureDate(until)
                    ? formatMessage({
                        id: "ui-br-legaldeposits.periodicalCheck.postpone.untilError",
                    })
                    : undefined }))),
        React.createElement(TextArea, { value: note, onChange: function (e) {
                return setNote(e.target.value);
            }, label: formatMessage({
                id: "ui-br-legaldeposits.periodicalCheck.postpone.noteLabel",
            }) })));
};
